import React, { useContext } from 'react'
import NoEvents from '../../../assets/no_upcoming_events.png'
import { Event } from './event'
import { DashboardContext } from '../../../context/DashboardContext'
import { toast } from 'react-hot-toast'

function Loader() {
  return (
    <div className="flex justify-center items-center">
      <svg className="w-40 h-40" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 200">
        <radialGradient id="a1" cx=".66" fx=".66" cy=".3125" fy=".3125" gradientTransform="scale(1.5)">
          <stop offset="0" stopColor="#FF156D"></stop>
          <stop offset=".3" stopColor="#FF156D" stopOpacity=".9"></stop>
          <stop offset=".6" stopColor="#FF156D" stopOpacity=".6"></stop>
          <stop offset=".8" stopColor="#FF156D" stopOpacity=".3"></stop>
          <stop offset="1" stopColor="#FF156D" stopOpacity="0"></stop>
        </radialGradient>
        <circle
          transform-origin="center"
          fill="none"
          stroke="url(#a1)"
          strokeWidth="15"
          strokeLinecap="round"
          strokeDasharray="200 1000"
          strokeDashoffset="0"
          cx="100"
          cy="100"
          r="70"
        >
          <animateTransform
            type="rotate"
            attributeName="transform"
            calcMode="spline"
            dur="2"
            values="360;0"
            keyTimes="0;1"
            keySplines="0 0 1 1"
            repeatCount="indefinite"
          ></animateTransform>
        </circle>
        <circle
          transform-origin="center"
          fill="none"
          opacity=".2"
          stroke="#FF156D"
          strokeWidth="15"
          strokeLinecap="round"
          cx="100"
          cy="100"
          r="70"
        ></circle>
      </svg>
    </div>
  )
}

interface EventsProps {
  limit: number
  events: any[]
  eventsLoading: boolean
}

export function Events({ limit, events, eventsLoading }: EventsProps) {
  const { activeWorkspace } = useContext(DashboardContext)

  async function copyToClipboard() {
    try {
      await navigator.clipboard.writeText(`invite+${activeWorkspace.stem}@evermuse.com`)
      toast.success('Copied!')
    } catch (err) {
      console.log(err)
      toast.error('Failed to copy!')
    }
  }

  return (
    <>
      <div className="mt-12">
        <div className="rounded-2xl shadow pt-2 pb-3" style={{ width: '98%', backgroundColor: '#fdfdfd' }}>
          {eventsLoading ? (
            <Loader />
          ) : events?.length ? (
            <>
              <div className="p-8">
                <div className="text-zinc text-[1.625rem] font-semibold font-['Manrope'] mb-6">Upcoming meetings</div>
                <div className="flex flex-wrap gap-3 items-center overflow-hidden">
                  {events.slice(0, limit).map((event, index) => (
                    <Event key={event.id} event={event} />
                  ))}
                </div>
              </div>
            </>
          ) : (
            <div className="flex justify-between items-center my-6">
              <div className="ml-9">
                <div className="text-zinc text-[1.625rem] font-semibold font-['Manrope']">Upcoming meetings</div>
                <p className="w-[420px] mt-6 text-grey-500 text-base font-normal font-['Manrope'] leading-[23px]">
                  The
                  <span className="text-grey-500 text-base font-bold font-['Manrope'] leading-[23px]">
                    {' '}
                    Evermuse Bot{' '}
                  </span>
                  has not been invited to any user meetings yet. Simply invite him at:{' '}
                  <span
                    className="text-blue text-base font-bold font-['Manrope'] leading-[23px] cursor-pointer"
                    onClick={copyToClipboard}
                  >
                    invite+{activeWorkspace.stem}@evermuse.com
                  </span>{' '}
                  (Or use a project-specific email to group sessions.)
                </p>
              </div>
              <img className="mr-10" src={NoEvents} alt="No Upcoming meetings" />
            </div>
          )}
        </div>
      </div>
    </>
  )
}
